"use strict";

var SessionClient = require('./session');

module.exports = SessionClient;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/session/lib/client/index.js
// module id = 115
// module chunks = 0 1